import { menuCampaign, rightMini } from "assets/icons";
import styled from "@emotion/styled";
import { Col } from "antd";
import { Typography } from "antd";
import { FC } from "react";

interface CardMenuProfileProps {
  title: string;
  icon: any;
  func: () => void;
}

const CardMenuProfile: FC<CardMenuProfileProps> = ({ title, icon, func }) => {
  return (
    <Col
      xs={{ span: 24 }}
      sm={{ span: 24 }}
      md={{ span: 24 }}
      xl={{ span: 24 }}
    >
      <CardWrapper
        onClick={() => {
          func();
        }}
      >
        <LeftWrapper>
          <IconWrapper>{icon}</IconWrapper>
          <Typography.Text
            style={{
              fontSize: 14,
              fontWeight: 400,
              marginBottom: 5,
              marginLeft: 5,
            }}
          >
            {title}
          </Typography.Text>
        </LeftWrapper>
        <IconWrapper
          onClick={() => {
            func();
          }}
        >
          {rightMini}
        </IconWrapper>
      </CardWrapper>
    </Col>
  );
};

export default CardMenuProfile;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 10px;
  // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  &:hover {
    // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  }
  border-bottom: 1px solid #efefef;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;
